import {FeaturesEnum} from 'presentation/constants';
import {useAccountInformation} from 'presentation/pages';
import {useGetHealthCardQuery} from 'presentation/pages/private/health-card/queries/useGetHealthCardQuery';
import {UseReverseNetworkOrderProps} from './types';
import {useFeatureFlag} from '../useFeatureFlag';

export function useReverseNetworkOrder({flowType}: UseReverseNetworkOrderProps) {
	const {isPPOPlan} = useAccountInformation();
	const {data: healthCardData} = useGetHealthCardQuery();
	const isInfinityPlan = healthCardData?.dsModelo?.toLowerCase() === 'infinity';
	const isAdvancePlan = healthCardData?.dsModelo?.toLowerCase() === 'advance';
	const isPremiumPlan = healthCardData?.dsModelo?.toLowerCase() === 'premium';

	const {isEnabled: isHealthInfinityEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_HEALTH_INFINITY,
	);
	const {isEnabled: isExamInfinityEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_EXAMS_INFINITY,
	);
	const {isEnabled: isGuideInfinityEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_GUIDE_INFINITY,
	);
	const {isEnabled: isHealthAdvanceEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_HEALTH_ADVANCE,
	);
	const {isEnabled: isExamAdvanceEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_EXAMS_ADVANCE,
	);
	const {isEnabled: isGuideAdvanceEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_GUIDE_ADVANCE,
	);
	const {isEnabled: isHealthPremiumEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_HEALTH_PREMIUM,
	);
	const {isEnabled: isExamPremiumEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_EXAMS_PREMIUM,
	);
	const {isEnabled: isGuidePremiumEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_NETWORK_INVERSION_GUIDE_PREMIUM,
	);

	const flagsByFlow = {
		HEALTH: {
			infinity: isHealthInfinityEnabled,
			advance: isHealthAdvanceEnabled,
			premium: isHealthPremiumEnabled,
		},
		EXAM: {
			infinity: isExamInfinityEnabled,
			advance: isExamAdvanceEnabled,
			premium: isExamPremiumEnabled,
		},
		GUIDE: {
			infinity: isGuideInfinityEnabled,
			advance: isGuideAdvanceEnabled,
			premium: isGuidePremiumEnabled,
		},
	};

	const flags = flagsByFlow[flowType];

	const shouldReverseNetworkOrder =
		isPPOPlan &&
		((isInfinityPlan && flags.infinity) ||
			(isAdvancePlan && flags.advance) ||
			(isPremiumPlan && flags.premium));

	return {shouldReverseNetworkOrder};
}
